import { validaCpf, validaCnpj } from "../utils/DocumentoUtil";
/**
 * Recebe um numero formatado em string e retorna em float: Ex: 1.400,15 se torna 1400.15
 * @param n
 * @param decimals
 * @returns
 */
export const numeroToNumber = function (n, decimals = 2) {
    if (typeof n !== "string") {
        return 0.0;
    }
    var num = n
        .replace(/[^0-9\.,\-]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
    if (n)
        num = Number(num).toFixed(decimals);
    return Number(num);
};
/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
const format = function (myNumber, n, x, s, c) {
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")", num = myNumber.toFixed(Math.max(0, ~~n));
    return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
};
/**
 * Recebe um float e retorna formatado: Ex: 1400.15 se torna 1.400,15
 * @param n
 * @param decimals
 * @returns
 */
export const numberToNumero = function (myNumber, prefixo = "") {
    return prefixo + format(myNumber, 2, 3, ".", ",");
};
export const moneyToReais = (money) => {
    return numberToNumero(money, "R$ ");
};
/**
 * Remove todos os acentos e caracteres especiais de uma string
 * @param str
 * @returns
 */
export const removeAccents = (str = "") => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
export function converteData(data) {
    if (!data)
        return data;
    var parts = data.match(/(\d+)/g);
    if (!parts[2]) {
        console.log("String inválida para conversão de data!");
        return "";
    }
    if (parts[2].length === 4) {
        //data em formato dd/mm/yyyy
        return parts[2] + "-" + parts[1] + "-" + parts[0];
    }
    else if (parts[0].length === 4) {
        //data em formato yyyy-mm-dd
        return parts[2] + "/" + parts[1] + "/" + parts[0];
    }
    else {
        console.log("String inválida para conversão de data.");
    }
}
export function converteDataHora(data) {
    if (!data)
        return data;
    var parts = data.match(/(\d+)/g);
    if (!parts[3] || !parts[4]) {
        console.log("String inválida para conversão de data/hora!");
        return "";
    }
    if (parts[2].length === 4) {
        //data em formato dd/mm/yyyy
        return (parts[2] +
            "-" +
            parts[1] +
            "-" +
            parts[0] +
            " " +
            parts[3] +
            ":" +
            parts[4]);
    }
    else if (parts[0].length === 4) {
        //data em formato yyyy-mm-dd
        return (parts[2] +
            "/" +
            parts[1] +
            "/" +
            parts[0] +
            " " +
            parts[3] +
            ":" +
            parts[4]);
    }
    else {
        console.log("String inválida para conversão de data/hora.");
    }
}
export function isCpfValido(cpf) {
    return validaCpf(cpf);
}
export function isCnpjValido(cnpj) {
    return validaCnpj(cnpj);
}
export function slugify(str) {
    return str
        .toString()
        .toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, "a") // Special Characters #1
        .replace(/[èÈéÉêÊëË]+/g, "e") // Special Characters #2
        .replace(/[ìÌíÍîÎïÏ]+/g, "i") // Special Characters #3
        .replace(/[òÒóÓôÔõÕöÖº]+/g, "o") // Special Characters #4
        .replace(/[ùÙúÚûÛüÜ]+/g, "u") // Special Characters #5
        .replace(/[ýÝÿŸ]+/g, "y") // Special Characters #6
        .replace(/[ñÑ]+/g, "n") // Special Characters #7
        .replace(/[çÇ]+/g, "c") // Special Characters #8
        .replace(/[ß]+/g, "ss") // Special Characters #9
        .replace(/[Ææ]+/g, "ae") // Special Characters #10
        .replace(/[Øøœ]+/g, "oe") // Special Characters #11
        .replace(/[%]+/g, "pct") // Special Characters #12
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
}
export function getBase64(file) {
    var p = new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.onerror = function (error) {
            reject(error);
        };
    });
    return p;
}
export async function copiarLink(str, elementRef) {
    try {
        await navigator.clipboard.writeText(str);
        if (elementRef) {
            $(elementRef).attr("title", "Copiado!").tooltip("show");
            setTimeout(function () {
                //@ts-ignore
                $(elementRef).attr("title", "Copiar").tooltip("destroy");
            }, 2000);
        }
    }
    catch (err) {
        console.error("Async: Could not copy text: ", err);
        alert("Seu navegador não possui suporte para cópia virtual de texto.");
    }
}
export default {};
